import { RequestFactory } from "@/requests/RequestFactory";
const projetoRequest = RequestFactory.get("projeto");
const storageRequest = RequestFactory.get("storage");

function dateRange(startDate, endDate) {
  var start      = startDate.split('-');
  var end        = endDate.split('-');
  var startYear  = parseInt(start[0]);
  var endYear    = parseInt(end[0]);
  var dates      = [];

  for(var i = startYear; i <= endYear; i++) {
    var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
    var startMon = i === startYear ? parseInt(start[1])-1 : 0;
    for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
      var month = j+1;
      var displayMonth = month < 10 ? '0'+month : month;
      dates.push([i, displayMonth, '01'].join('-'));
    }
  }
  return dates;
}

export default {
  namespaced: true,
  indice: 0,

  state: {
    isFetching: false,
    items: {},
    itemStorageRoot: {}
  },

  mutations: {
    setItemStorageRoot(state, { item }) {
      state.itemStorageRoot[item.id] = item
    },
    SET_PARTICIPANTE(state, payload) {
      state.participante = payload;
    },
    
    SET_PARTICIPANTE_COM_PERMISSAO(state, payload) {
      state.items[payload.projetoId].participantes = payload.participantes
    },

    DELETE_PARTICIPANTE(state, { itemId, index }) {
      state.items[itemId].organizacoes.splice(index, 1)
    },

    DELETE_ORGANIZACAO(state, { itemId, index }) {
      state.items[itemId].organizacoes.splice(index, 1)
    },

    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    }

  },

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchAllProjetos: ({ dispatch }) => dispatch('fetchAllItems', { resource: 'projeto' }, { root: true }),

    fetchProjeto: ({ dispatch, commit }, projetoId) => {
      dispatch("usuario/getUsuario", null, { root: true })
      dispatch('requestOn')
      return storageRequest.root(projetoId).then(response => {
        dispatch('requestOff')
        const payload = { resource: 'projeto', id: projetoId }
        return dispatch('fetchItem', payload, { root: true }).then(() => {
          const item = response.data
          commit('setItemStorageRoot', { item })
          dispatch('definePermissions', {'projetoId': projetoId})
        })

        
      })
    },

    definePermissions({state, commit}, {projetoId}) {
      commit;
      var participantes = state.items[projetoId].participantes

      let ps = participantes.map(p => {
        p.permissions = [];
        switch (p.papel) {
          case 'AGENTE_MONITORAMENTO_PROGRAMATICO':
            p.permissions.push(
              "PERMISSION_PROJETO_EDIT",
              "PERMISSION_PROJETO_VIEW",
              "PERMISSION_EQUIPE_EDIT",
              "PERMISSION_EQUIPE_VIEW",
              "PERMISSION_LOGICA_INTERVERCAO_EDIT",
              "PERMISSION_LOGICA_INTERVERCAO_VIEW",
              "PERMISSION_INDICADOR_EDIT",
              "PERMISSION_INDICADOR_VIEW",
              "PERMISSION_LANCAMENTO_FONTE_EDIT",
              "PERMISSION_LANCAMENTO_FONTE_VIEW",
              "PERMISSION_MONITORAMENTO_INDICADOR_EDIT",
              "PERMISSION_MONITORAMENTO_INDICADOR_VIEW"
            );
            break;        
        
          case 'AGENTE_LANCAMENTO_FONTES':
            p.permissions.push(
              "PERMISSION_PROJETO_VIEW",
              "PERMISSION_EQUIPE_VIEW",
              "PERMISSION_LOGICA_INTERVERCAO_VIEW",
              "PERMISSION_INDICADOR_VIEW",
              "PERMISSION_LANCAMENTO_FONTE_EDIT",
              "PERMISSION_LANCAMENTO_FONTE_VIEW",
              "PERMISSION_MONITORAMENTO_INDICADOR_VIEW"
            );
            break;        
        
          case 'AGENTE_MONITORAMENTO_FINANCEIRO':
            p.permissions.push(
              "PERMISSION_PROJETO_VIEW",
              "PERMISSION_EQUIPE_VIEW",
              "PERMISSION_LOGICA_INTERVERCAO_VIEW",
              "PERMISSION_INDICADOR_VIEW",
              "PERMISSION_LANCAMENTO_FONTE_VIEW",
              "PERMISSION_MONITORAMENTO_INDICADOR_VIEW"
            );
            break;

          case 'AGENTE_PRESTACAO_CONTA':
            p.permissions.push(
              "PERMISSION_PROJETO_VIEW",
              "PERMISSION_EQUIPE_VIEW",
              "PERMISSION_LOGICA_INTERVERCAO_VIEW",
              "PERMISSION_INDICADOR_VIEW",
              "PERMISSION_LANCAMENTO_FONTE_VIEW",
              "PERMISSION_MONITORAMENTO_INDICADOR_VIEW"
            );
            break; 
    
          case 'COMISSAO_PRESTACAO_CONTA':
            p.permissions.push(
              "PERMISSION_PROJETO_VIEW",
              "PERMISSION_EQUIPE_VIEW",
              "PERMISSION_LOGICA_INTERVERCAO_VIEW",
              "PERMISSION_INDICADOR_VIEW",
              "PERMISSION_LANCAMENTO_FONTE_VIEW",
              "PERMISSION_MONITORAMENTO_INDICADOR_VIEW"
            );
            break; 
          
          case 'COORDENADOR_INSTITUCIONAL':
            p.permissions.push(
              "PERMISSION_PROJETO_VIEW",
              "PERMISSION_EQUIPE_VIEW",
              "PERMISSION_LOGICA_INTERVERCAO_VIEW",
              "PERMISSION_INDICADOR_VIEW",
              "PERMISSION_LANCAMENTO_FONTE_VIEW",
              "PERMISSION_MONITORAMENTO_INDICADOR_VIEW"
            );
            break;  
            
          case 'FINANCIADOR':
            p.permissions.push(
              "PERMISSION_PROJETO_VIEW",
              "PERMISSION_EQUIPE_VIEW",
              "PERMISSION_LOGICA_INTERVERCAO_VIEW",
              "PERMISSION_INDICADOR_VIEW",
            );
            break;  
          default:
        }
        return p;
      });
      const payload = { 'projetoId': projetoId, 'participantes': ps }
      commit('SET_PARTICIPANTE_COM_PERMISSAO', payload);
    },

    criarProjeto({ commit, dispatch }, projeto) {
      dispatch('requestOn')
      return projetoRequest.post(projeto).then(response => {
        dispatch('requestOff')
        const payload = { resource: 'projeto', item: response.data }
        commit('setItem', payload, { root: true })
        return response.data
      })
    },

    editarProjeto({ commit, dispatch }, projeto) {
      dispatch('requestOn')
      projeto.participantes = null
      return projetoRequest.put(projeto.id, projeto).then(response => {
        dispatch('requestOff')
        const payload = { resource: 'projeto', item: response.data }
        commit('setItem', payload, { root: true })
        return response.data
      })
    },

    deletarProjeto({ commit, dispatch }, projetoId) {
      dispatch('requestOn')
      return projetoRequest.delete(projetoId).then(() => {
        dispatch('requestOff')
        const payload = { resource: 'projeto', itemId: projetoId }
        commit('deleteItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Projeto removido com sucesso'
        }

        return dispatch('notification/add', notification, { root: true })
      })
    },

    getProjetoById({context, dispatch}, id) {
      dispatch('requestOn')
      projetoRequest.findById(id).then(function (result) {
        dispatch('requestOff')
        context.commit('SET_PARTICIPANTE', result.data);
      });
      return this.state.participante
    },

    addParticipante({ dispatch }, data) {
      dispatch('requestOn')
      projetoRequest.addParticipante(data.projetoId, data.participante).then(() => {
        dispatch('requestOff')
        dispatch('projeto/fetchProjeto', data.projetoId, { root: true })
      });
    },

    deletarParticipante({ commit, dispatch }, data) {
      dispatch('requestOn')
      projetoRequest.removerParticipante(data.projetoId, data.participante.id).then(() => {
        dispatch('requestOff')
        const payload = {
          'itemId': data.projetoId,
          'index': data.index
        };
        commit('DELETE_PARTICIPANTE', payload)
      });
    },

    addOrganizacao({ dispatch }, data) {
      dispatch('requestOn')
      projetoRequest.addOrganizacao(data.projetoId, data.organizacaoId).then(() => {
        dispatch('requestOff')
        dispatch('projeto/fetchProjeto', data.projetoId, { root: true })
      });
    },

    deletarOrganizacao({ commit, dispatch }, data) {
      dispatch('requestOn')
      projetoRequest.removerOrganizacao(data.projetoId, data.organizacaoId).then(() => {
        dispatch('requestOff')
        const payload = {
          'itemId': data.projetoId,
          'index': data.index
        };
        commit('DELETE_ORGANIZACAO', payload)
      });
    },

    getIndicadoresByProjetoId({commit}, projetoId) {
      return projetoRequest.findIndicadoresByProjetoId(projetoId).then(response => {
        response.data.forEach(item =>  commit('setItem', {item, resource: 'indicador'}, {root: true}))
      });
    },

  },

  getters: {
    all: state => {
      return state.items ? Object.values(state.items) : []
    },

    getProjetoById: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .find(projeto => projeto.id === projetoId)
      }
      return {}
    },

    getRootByProjetoId: (state) => projetoId => {
      if (state.itemStorageRoot) {
        return Object.values(state.itemStorageRoot)
          .find(item => item.projeto.id === projetoId)
      }
      return {}
    },

    getMeses: (state) => projetoId => {
      let projeto = state.items[projetoId];
      let termino = projeto.extensao === null ? projeto.termino : projeto.extensao
      return dateRange(projeto.inicio, termino)
    },

    participanteAtual: (state) => payload => {      
      return state.items[payload.projetoId].participantes.find(participante => participante.usuario.id === payload.usuarioId)
    },

    getParticipantes: (state) => projetoId => {
      return state.items[projetoId].participantes
    },

    getParticipantesByPapel: (state) => payload => {
      return state.items[payload.projetoId].participantes.filter(participante => participante.papel === payload.papel)
    },

    hasPermission: (state) => payload => {
      let arrayPermission = []
      state.items[payload.projetoId].participantes.forEach(participante => {
        if(participante.usuario.id === payload.usuarioId) {
          arrayPermission = arrayPermission.concat(participante.permissions)
        }
      });

      if (Array.isArray(payload.permission)) {
        return payload.permission.some(p => arrayPermission.includes(p))
      }

      return arrayPermission.includes(payload.permission);
    },

    hasPapel: (state) => payload => {
      let arrayPapel = []
      
      if(state.items[payload.projetoId]) {
        state.items[payload.projetoId].participantes.forEach(participante => {
          if(participante.usuario.id === payload.usuarioId) {
            arrayPapel.push(participante.papel)
          }
        });          
      }

      return arrayPapel.includes(payload.papel);
    },

    getPapeisParticipante: (state) => payload => {
      let papeis = []
      state.items[payload.projetoId].participantes.forEach(participante => {
        if(participante.usuario.id === payload.usuarioId) {
          papeis.push(participante.papel)
        }
      });
      return papeis;
    },



  },


}
